/**
 * Use `rubic` if swap is sent through rubic-proxy contract.
 * Use `rubic_widget` if swap is sent directly through bridgers contract.
 */
export type BridgersSourceFlag = 'rubic' | 'rubic_widget';
